<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="标签名" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入标题"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="6">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd('新增用户')">新增</el-button>
      <el-table :data="tableData" border default-expand-all stripe :header-cell-style="{'text-align':'center'}" style="width: 100%;margin-bottom: 20px;" @select-change="handleSelectionChange">
        <el-table-column label="全选" width="50" type="selection"/>
        <el-table-column prop="userName" label="标签名称" />
        <el-table-column prop="goodsImgUrl" label="排序(从小到大)" />
        <el-table-column prop="remarks" label="备注" />
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle
                       @click="handleEdit(scope.$index, scope.row,'修改字典项')">
              编辑
            </el-button>
            <el-button size="mini" type="success"
                       @click="handleDelete(scope.$index, scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from "@/components/MixinCUD";

export default {
  name: "TagManagelist",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryForm:{

      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
.el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(31, 158, 254);
  color: rgb(255, 255, 255);
}
</style>
